import request from '@/utils/request'
import axios from 'axios'

// 微信授权
export function GetIndex(data) {
    return request({
        url: '/api/Auth/GetAuthUrl?bu=' + encodeURIComponent(data),
        method: 'get',
    })
}

// 获取用户信息
export function UserInfo(data) {
    return request({
        url: '/api/User/UserInfo?track=' + data,
        method: 'get',
    })
}
// 刷新cookie
export function RefreshToken(data) {
    return request({
        url: '/api/Auth/RefreshToken',
        method: 'get',
    })
}

// 微信分享
export function gethlSignature() {
    return request({
        // url: 'https://mic.arcdmi.com/wcp/api/jsticket',
        url: '/api/Auth/JSTicket',
        method: 'get',
        params: {
            url: window.location.href
                // url: window.location.href.split('?')[0]
        }
    })
}
// // 微信分享
// export function gethlSignature1() {
//     return request({
//         url: 'https://mic.arcdmi.com/wcp/api/jsticket',
//         method: 'get',
//         params: {
//             wechatId:'92775e25-7410-43bb-b013-8d3b8b2192b7',  //  测试 id  5fbb3ab9-2b55-4179-9ed0-ecab9b0c0a7b  正式id  92775e25-7410-43bb-b013-8d3b8b2192b7
//             url:window.location.href
//         }
//     })
// }

// 加积分
export function AddPoints(data) {
  return request({
    url: "/api/User/AddPoints",
    method: "get",
    params: {
      visitType: data.visitType,
      track: data.track,
      name: data.name,
      email: data.email,
    },
    // ...config, // 合并传入的配置
  });
}

// 加积分-不等待返回
export function AddAyPoints(data) {
  return request({
    url: "/api/User/AddAyPoints",
    method: "get",
    params: {
      visitType: data.visitType,
      track: data.track,
      name: data.name,
      email: data.email,
    },
  });
}

// 判断新品展示答题是否提交
export function SubmitNewProduct(data) {
    return request({
        url: '/api/User/SubmitNewProduct',
        method: 'get',
        params: {
            answerCode: data
        }
    })
}

// 展示答题提交
export function SubmitNewProductPost(data, track) {
    return request({
        url: '/api/User/SubmitNewProduct',
        method: 'post',
        params: {
            track: track
        },
        data: {
            id: '',
            Answer: data.answer,
            AnswerCode: data.answerCode
        }
    })
}


//提交有奖调研
export function SubmitExamination(data, track) {
    return request({
        url: '/api/User/SubmitExamination',
        method: 'post',
        params: {
            track: track
        },
        data: data
    })
}


// 获取个人中心页信息
export function UserIntegralInfo(track) {
    return request({
        url: '/api/User/UserIntegralInfo',
        method: 'get',
        params: {
            track: track
        }
    })
}

// 获取兑换奖品信息
export function GetExchangePrize(openId) {
    return request({
        url: '/api/Prize/GetExchangePrize?openId=' + openId,
        method: 'get',
    })
}

// 兑换奖品
export function ExchangePrize(openId, pids) {
    return request({
        url: '/api/Prize/ExchangePrize?openId=' + openId + '&pids=' + pids,
        method: 'get',
    })
}
// 获取直播间问卷
export function GetLinkExamination(params) {
    return request({
        url: '/api/User/GetLinkExamination',
        method: 'get',
        params
    })
}

// 直播问卷提交
export function SubmitLinkExamination(data, track) {
    return request({
        url: '/api/User/SubmitLinkExamination',
        method: 'post',
        params: {
            track: track
        },
        data: data
    })
}


// 获取直播间
export function GetLiveInfo(params) {
    return request({
        url: '/api/User/GetLiveInfo',
        method: 'get',
        params,
    })
}

// 访问记录接口
export function GetUserLogs(params) {
    return request({
        url: '/api/BehaviorRecord/GetUserLogs',
        method: 'get',
        params
    })
}

// 判断是否注册
export function ReadNotice() {
    return request({
        url: '/api/User/ReadNotice',
        method: 'get'
    })
}

// 分享海报
export function GetSharePoster(params) {
    return request({
        url: 'https://events.schneider-electric.cn/miniPlan/gongBoSaleRegister',
        // url: '/miniPlan/gongBoSaleRegister', //本地
        method: 'post',
        params: params,
        type: 'out'
    })
}


// // 获取直播间观看人数
// export function GetOnlineVisitorList (params) {
//     return request({
//         url: '/api/User/GetOnlineVisitorList',
//         method: 'get',
//         params
//     })
// }

// 获取直播间观看人数
export function GetOnlineVisitorList(data) {
    return request({
        url: `https://api.mudu.tv/v1/activities/${data.liveId}/onlineVisitorList`,
        method: 'get',
        type: 'live'
    })
}

export function UserLiveInfo(params) {
    return request({
        url: '/api/User/userLiveInfo',
        method: 'get',
        params
    })
}

export function PersonnelMine(params) {
    return request({
        url: `https://api.event.mudu.com/sdk/personnel/mine`,
        method: 'get',
        type: 'live',
        params
    })
}